<template>
    <div full-height>

        <v-toolbar flat fixed>
            <v-toolbar-title>{{ $t('restoreData.toolbarTitle') }}</v-toolbar-title>
            <v-spacer></v-spacer>

             <!-- <v-menu>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <img src="../../assets/icon_help.svg" style="width:20px"/>
                    </v-btn>
                </template>
                <v-list dense nopadding>
                    <v-list-item @click="$root.fn_whatsAppSupport">
                        <v-list-item-action class="mr-2"><img src="../../assets/icon_whatsapp.svg" style="width:20px"/></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Contact Support</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu> -->

            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <img src="../../assets/more-icon.svg" style="width:24px"/>
                </v-btn>
              </template>
              <v-list nopadding>
                <!-- <v-list-item v-if="dbFileExist" @click="fn_reopenDatabase(null)">
                  <v-list-item-title>Restore from device</v-list-item-title>
                </v-list-item> -->
                <v-list-item @click="fn_confirmDeactivate">
                  <v-list-item-title>{{ $t('restoreData.registerNewBusiness') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="fn_freshStartDialog" v-if="$root.CurrentBusiness && $root.CurrentBusiness.BusinessID == '1dbe3d66-7ac3-4573-8001-eaddb8c44614'">
                  <v-list-item-title>{{ $t('restoreData.continueWithoutRestore') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="fn_logOut">
                  <v-list-item-title style="color: red;">{{ $t('restoreData.logout') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
             <!-- <v-menu v-if="businessList && businessList.length>1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <img src="../../assets/more-icon.svg" style="margin-top:5px; width:28px"/>
                </v-btn>
              </template>
              <v-list nopadding>
                <v-list-item @click="fn_openDialogDeCtivateBusiness">
                  <v-list-item-title>Deactivate Old Business</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
        </v-toolbar>

        <div class="hastoolbar" style="height:100%">
            <v-card noshadow v-if="$root.CurrentBusiness">
                <v-card-text>

                    <div center-align>
                        <p class="title primary-color" style="line-height:28px !important">
                            {{ $t('restoreData.chooseGoogleAccount') }}
                            <!-- Setup a google drive for <span dark-opacity-color>
                                <strong>{{$root.CurrentBusiness.BusinessName}}</strong>
                                Abc Corp Ltd.
                            </span> 
                                to backup your business data -->
                        </p><br>

                        <div style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px">
                            <!-- <v-icon class="primary-color" style="font-size:42px">person</v-icon> -->
                            <img src="../../assets/icon_person.svg" style="width:44px"/>
                        </div><br>

                        <p class="title grey-color" style="line-height:28px !important">
                            <!-- Sign in to restore your data from your Google Drive -->
                            {{ $t('restoreData.signInPrefix') }}<br>
                            "{{$root.CurrentBusiness.BusinessName}}"<br>
                            {{ $t('restoreData.signInMiddle') }}<br>
                            "{{$root.CurrentBusiness.DataDrive}}"
                        </p><br>

                        <div>
                            <v-btn color="primary" @click="fn_showGoogleAccounts('sign_in')">
                                {{ $t('restoreData.signInBtn') }}
                            </v-btn>
                        </div><br>

                        <p class="grey-color font12" style="line-height:20px !important">
                            {{ $t('restoreData.disclaimer') }}
                        </p>

                        <!-- <div class="mt-4">
                            <v-btn color="primary" @click="fn_restoreFromFirebase">
                                Restore
                            </v-btn>
                        </div><br> -->

                        <!-- <p class="grey-color" style="line-height:28px !important">OR</p>

                        <v-btn text color="primary" style="background:#eee" @click="fn_confirmDeactivate">
                            Register New Business
                        </v-btn> -->
                    </div>

                </v-card-text>
            </v-card>

            <v-footer class="bottom-fixed-footer" style="background-color: #fff;">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 mb-2 center-align @click="$root.fn_whatsAppSupport">
                        <div class="pa-4 pb-0" font14 style="letter-spacing: 0.5px;font-weight: 500;"><span style="color: #4b77be;"><img src="../../assets/icon_support.svg" style="width:20px;margin-bottom: -4px;"/> {{ $t('common.contactSupport') }}</span></div>
                    </v-flex>
                </v-layout>
            </v-footer>
            <!-- <v-card noshadow style="height:calc(50% - 2px)">
                <v-card-text>
                    <div center-align v-if="$root.CurrentBusiness && $root.CurrentBusiness.DataDrive">
                        <p class="title grey-color" style="line-height:28px !important">
                            Select <span dark-opacity-color><strong>{{$root.CurrentBusiness.DataDrive}}</strong></span> to restore data of
                            <span v-if="$root.CurrentBusiness" dark-opacity-color><strong>{{$root.CurrentBusiness.BusinessName}}</strong></span>
                        </p><br>

                        <div>
                            <v-btn color="primary" @click="fn_showGoogleAccounts">Restore</v-btn>
                        </div>
                    </div>
                </v-card-text>

            </v-card>

            <v-divider></v-divider>

            <v-card noshadow style="height:50%">

                <v-card-text>

                    <div center-align v-if="$root.CurrentBusiness && $root.CurrentBusiness.BusinessName">
                        <p class="title grey-color" style="line-height:28px !important">
                            Deactivate
                            <span dark-opacity-color><strong>{{$root.CurrentBusiness.BusinessName}}</strong></span>
                            to register new business
                        </p><br>

                        <div>
                            <v-btn color="primary" @click="fn_confirmDeactivate">Deactivate</v-btn>
                        </div>
                    </div>

                </v-card-text>

            </v-card> -->


            <!-- <div class="page-footer">
                <div class="watermark">
                    <div class="title">BizOps</div>
                </div>
            </div> -->
        </div>
        
        <v-dialog v-model="restoreDialog" no-click-animation persistent max-width="290">
            <v-card>
                <v-card-text display-block>
                    <div class="pt-3 pb-3">{{ $t('restoreData.restoringData') }} {{restoreStatus ? restoreStatus + '%' : ''}}</div>
                    <v-progress-linear indeterminate v-if="!restoreStatus"></v-progress-linear>
                    <v-progress-linear v-model="restoreStatus" :buffer-value="bufferSize" buffer v-else></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod" :hideClose="hideClose" :okBtnText="okBtnText" :cancelBtnText="cancelBtnText"></dialog-confirmation>

        <dialog-deactivate-business ref="ref_dialogDeactivateBusiness" :businesses="businessList" :deactivate="fn_getTokenToDeactivate"></dialog-deactivate-business>

        <dialog-permission ref="ref_dialogPermission"></dialog-permission>

        <v-snackbar :timeout="0" v-model="msgAlert">{{ $t('common.somethingWentWrongAlert') }}
            <v-btn text color="primary" @click.native="fn_getToken">{{ $t('common.retryCap') }}</v-btn>
        </v-snackbar>

        <v-dialog v-model="dialog_update" no-click-animation persistent max-width="290">
            <v-card>
                <v-card-title style="box-shadow: none;">{{ $t('restoreData.appUpdateAvailable') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    {{ $t('restoreData.updateMessagePrefix') }}<span style="font-weight: 500;">{{ $t('restoreData.playStore') }}</span>{{ $t('restoreData.updateMessageSuffix') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" text @click="dialog_update=false">{{ $t('common.later') }}</v-btn>
                    <v-btn small color="primary" text @click.native="fn_openPlayStore">{{ $t('restoreData.updateNow') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

const dialogjs =  require('../../dialog').dialogjs;

import dialogConfirmation from '../dialogs/dialog_confirmation'
import dialogDeactivateBusiness from './dialogs/dialog_deactivate_business'
import dialogPermission from '../dialogs/dialog_permission'

    export default{
        data(){
            return{
                isBack:true,
                confirmationMessage:null,
                confirmationHeader:null,
                actionMethod:null,
                dialogStorageId:null,
                restoreStatus:null,
                bufferSize:100,
                restoreDialog:null,
                restoreStatusObj:null,
                msgAlert:false,
                hideClose:false,
                businessList:[],
                permissionType:null,
                dialog_update:false,
                okBtnText:null,
                cancelBtnText:null,
                // dbFileExist:null
            }
        },
        components:{
            'dialog-confirmation': dialogConfirmation,
            'dialog-deactivate-business': dialogDeactivateBusiness,
            'dialog-permission':dialogPermission
        },
        methods:{

            fn_openDialogWeb: function (platform, name, ref) {

                let scroll_y = window.scrollY;
                this.fn_fixBackgroundScroll();

                var dialogObj = {};
                dialogObj.tagId = this.guidWeb();
                dialogObj.formId = this.formId;
                dialogObj.name = name;
                dialogObj.ref = ref;
                dialogObj.data = null;
                dialogObj.platform = platform;

                dialogObj.scrollPosition = {};
                dialogObj.scrollPosition.x = 0;
                dialogObj.scrollPosition.y = scroll_y;

                dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

                this.$refs[ref].openDialogWeb();
            },

            fn_openDialogConfirmation: function(type){
                if(type === 'deactivate' || type === 'fresh_data'){
                    this.okBtnText = this.$t('common.yes');
                    this.cancelBtnText = this.$t('common.no');
                }
                else{
                    this.okBtnText = null;
                    this.cancelBtnText = null;
                }
                this.fn_openDialogWeb('web', 'Confirmation', 'ref_dialogConfirmation')
            },

            fn_confirmAction: function(){
                this.fn_closeDialog();
                /*global AndroidRoutingTest*/
                // AndroidRoutingTest.revokeAccount();

                let self = this;
                setTimeout(function(){
                    self.fn_showGoogleAccounts();    
                },300);
            },

            fn_closeDialog: function () {
                AndroidRoutingTest.revokeAccount();
                dialogjs.fn_checkAndCloseOpenDialogs(this);
            },

            fn_showGoogleAccounts: function(type){
                if(type=='sign_in'){
                    this.confirmationHeader = null;
                }
                else{
                    // closing "Continue Without Restore" dialog
                    this.fn_closeDialog();
                }

                if(!navigator.onLine){
                    this.showToast(this.$t('restoreData.internetNotAvailableNoExcl'));
                    return;
                }

                if(this.$root.appVersion < 131){
                    this.dialog_update = true;
                    return;
                }

                let self = this;
                // /*global AndroidRoutingTest*/
                AndroidRoutingTest.revokeAccount();
                this.getData('ShowGoogleAccounts', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_checkDataDrive(response);
                        }, 
                        onError: function(error){
                            console.log(error);
                            if(error=="Request Cancel"){
                                console.log(error);
                            }
                            else if(!navigator.onLine){
                                self.showToast(self.$t('common.internetNotAvailable'));
                            }
                            else{
                                self.showToast(self.$t('common.somethingWentWrong'));
                            }
                            
                        }
                    }
                );
            },

            fn_checkDataDrive: function(dataDrive){
                if(dataDrive != this.$root.CurrentBusiness.DataDrive){
                    this.confirmationMessage = this.$t('restoreData.chooseConfigurePrefix') + this.$root.CurrentBusiness.DataDrive + this.$t('restoreData.chooseConfigureMiddle') + this.$root.CurrentBusiness.BusinessName + this.$t('restoreData.chooseConfigureSuffix');
                    this.actionMethod = this.fn_confirmAction;
                    this.hideClose = true;
                    this.fn_openDialogConfirmation();
                }
                else{
                    //updating data drives of all businesses in master
                    this.showLoading(this.$t('common.pleaseWait'));
                    this.fn_updateDataDrive(dataDrive);
                }
            },

            // dataDrive == selected/configured email id
            fn_updateDataDrive: function(dataDrive){
                let self = this;
                let postObj = {"dataDrive":dataDrive};
                this.postData('UpdateDataDrive', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            //Checking restore size to restore data files
                            if(self.confirmationHeader == self.$t('restoreData.startWithNewDataHeader')){
                                self.fn_freshStart();
                            }
                            else{
                                self.fn_checkRestoreSize();
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrong'));
                        }, 
                    }
                );
            },

            fn_checkRestoreSize: function(){

                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    self.hideLoading();
                    return;
                }

                let self = this;
                this.getData('RestoreSize', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);

                            self.restoreStatusObj = JSON.parse(response);
                            if(!self.restoreStatusObj.dbSize && !self.restoreStatusObj.localDbSize){
                                self.fn_reopenDatabase(-1)
                            }
                            else{
                                self.hideLoading();
                                // if(self.dbFileExist){
                                //     self.fn_backupDBToLocalArchive();
                                // }
                                // else{
                                //     self.fn_restoreData();
                                // }
                                
                                self.fn_restoreData();
                            }
                            
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrong'));
                        }
                    }
                );
            },

            fn_backupDBToLocalArchive: function(){
                let self = this;
                let filterObject = {"businessId":this.$root.CurrentBusiness.BusinessID}
                this.getFilterData('BackupDBToLocalArchive', null, filterObject,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_restoreData();
                        }, 
                        onError: function(error){
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrongShort'));
                            console.log(error);
                        }
                    }
                );
            },

            fn_updateRestoreStatus: function(status, callback, type){
                var self = this;
                let filterObject = {};
                filterObject.DataRestore = status;

                let businessId = this.$root.CurrentBusiness && this.$root.CurrentBusiness.BusinessID ? this.$root.CurrentBusiness.BusinessID : this.$route.query.activeBusinessId;

                this.postFilterData('RestoreStatus', businessId, filterObject, 
                    {
                        onSuccess: function(response){
                            console.log(response);

                            if(callback){
                                callback()
                            }
                            else{
                                if(status==-1){
                                    self.fn_getToken();
                                }
                                else{
                                    self.fn_reopenDatabase(status, type);                     
                                }
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast(self.$t('common.somethingWentWrong'));
                            self.hideLoading();
                        }
                    }
                );
            },

            // fn_getToken: function(type){
            fn_getToken: function(){
                this.msgAlert = false;
                let self = this;
                self.showLoading(self.$t('restoreData.gettingDetails'));
                this.$root.fn_getAuthToken(function(token){
                    if(token=='error'){
                        self.msgAlert = true;
                        self.hideLoading();
                    }
                    else{
                        self.fn_getActiveBusinessListFromServer(token);
                    }
                    // else if(type=='deactivate'){
                    //     self.fn_deactivateBusiness(token)
                    // }
                    // else{
                    //     self.fn_getActiveBusinessListFromServer(token);
                    // }
                })
            },

            fn_getActiveBusinessListFromServer: function(token){
                if(!navigator.onLine){
                    this.msgAlert = true;
                    this.showToast(this.$t('common.internetNotAvailable'));
                    this.hideLoading();
                    return;
                }
                
                let self = this;
                console.log('get active business list');
                let filterObject = {};
                filterObject.token = token;
                this.msgAlert = false;
                // this.showLoading('Getting Business List...');
                this.getServerData('GetAllActiveBusiness', filterObject, 
                    {
                        onSuccess: function(response){
                            self.hideLoading();
                            console.log(response);
                            self.businessList = JSON.parse(response);
                            self.$root.CurrentBusiness = self.businessList[0];
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.msgAlert = true;
                            self.hideLoading();
                        }, 
                    }
                );
            },

            fn_reopenDatabase: function(status, type){
                let self = this;
                this.getData('ReopenDataBase', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);

                                if(status === null){
                                    if(type==='fresh_data'){
                                        self.hideLoading();
                                        self.$root.fn_loadMainApp();
                                    }
                                    else{
                                        self.showToast(self.$t('restoreData.dataRestoreComplete'));
                                        // self.fn_saveBusinessDetail('loadMainApp');
                                        self.fn_getRestoredBusinessDetails();
                                        // self.$root.fn_loadMainApp();
                                    }
                                }
                                else if(type === 'fresh_data'){
                                    self.fn_saveBusinessDetail(type)
                                }
                                else{
                                    self.fn_getBusinessDetailsFromMainDB();
                                }
                        }, 
                        onError: function(error){
                            self.hideLoading();
                            console.log(error, 'error in opening database');
                            self.showToast(self.$t('common.somethingWentWrong'));
                        }
                    }
                );
            },

            fn_getBusinessDetailsFromMainDB: function(){
                let self = this;
                this.getData('BusinessDetailsFromMainDB', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log()
                            let data = JSON.parse(response);
                            //saving busness details in case of no data found of the business
                            if(!data){
                                self.fn_saveBusinessDetail();
                            }

                            //checking if diffrence in GSTRegistrationStatus btw local and server 
                            else if(data.GSTRegistrationStatus != self.$root.CurrentBusiness.GSTRegistrationStatus){
                                self.fn_updateTtf(function(){
                                    self.fn_saveBusinessDetail();
                                })
                            }
                        },
                        onError: function(error){
                            console.log(error);
                            self.showToast(self.$t('common.somethingWentWrong'));
                            self.hideLoading();
                        }
                    }
                );
            },

            fn_saveBusinessDetail: function(type){
                let self = this;
                let postObj = JSON.parse(JSON.stringify(this.$root.CurrentBusiness));
                postObj.CreatedOn = new Date(postObj.CreatedOn);
                postObj.ModifiedOn = new Date(postObj.ModifiedOn);
                postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;
                postObj.OpeningDate = postObj.OpeningDate ? new Date(postObj.OpeningDate) : null;
                type == 'fresh_data' ? postObj.backupTime = new Date() : '';
                postObj.isActive = 1;
                this.postData('SaveBusinessDetail', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(type=='loadMainApp'){
                                self.$root.fn_loadMainApp();
                            }
                            else{
                                self.$root.fn_pushDefaultJson(function(){
                                    self.fn_resetDatabase(type);
                                });
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrong'));
                        }, 
                    }
                );
            },

            fn_resetDatabase: function(type){
                let self = this;
                this.getData('ResetDatabase', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.hideLoading();
                            if(type != 'fresh_data' && (self.restoreStatusObj.logoSize || self.restoreStatusObj.chunkSize)){
                                self.fn_restoreData();
                            }
                            else{
                                // updating restore status to null after pushing default data
                                self.fn_updateRestoreStatus(null, null, type);      
                            }
                        }, 
                        onError: function(error){
                            console.log(error, 'error in reset database');
                            self.showToast(self.$t('common.somethingWentWrong'));
                            self.hideLoading();
                        }
                    }
                );
            },

            fn_restoreData: function(){

                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    self.hideLoading();
                    return;
                }

                console.log('Restore Start');
                this.restoreDialog = true;

                localStorage.setItem('partial_restore', 1);

                let self = this;
                this.getData('RestoreBusiness', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.restoreDialog = false;
                            self.restoreStatus = null;
                            if(localStorage.getItem('partial_restore')){
                                localStorage.removeItem('partial_restore');
                            }
                            self.fn_updateRestoreStatus(null);
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.restoreDialog = false;
                            self.restoreStatus = null;
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrong'));
                            self.fn_renameDBFile();
                        }
                    }
                );

            },

            fn_renameDBFile: function(){
                let filterObject = {"localDatabaseFileName":this.$root.CurrentBusiness.BusinessID}
                this.getFilterData('RenameTempBusinessFile', null, filterObject,
                    {
                        onSuccess: function(response){
                            console.log(response);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_setRestoreStatus: function(status){
                this.restoreStatus = status;
            },

            fn_quit: function(){
                var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
                if(dialogData && dialogData.length){
                    dialogjs.fn_checkAndCloseOpenDialogs(this);
                }
                else{
                    this.confirmationMessage = null;
                    this.confirmationHeader = this.$t('restoreData.quitBusinessRestoreHeader');
                    this.actionMethod = this.fn_quitConfirmation;
                    this.hideClose = false;
                    this.fn_openDialogConfirmation();
                }
            },

            fn_quitConfirmation: function(){
                this.fn_closeDialog();
                let self = this;
                setTimeout(function(){
                    self.exitApp();
                },300);
            },

            fn_confirmDeactivate: function(){
                this.confirmationHeader = this.$t('restoreData.deleteBusinessHeader');
                this.confirmationMessage = this.$t('restoreData.deleteBusinessMessage');
                this.actionMethod = this.fn_getTokenToDeactivate;
                this.fn_openDialogConfirmation('deactivate');
            },

            fn_openDialogDeCtivateBusiness: function(){
                this.fn_openDialogWeb('web', 'Deactivate', 'ref_dialogDeactivateBusiness');
            },

            fn_getTokenToDeactivate: function(item, index){
                let self = this;
                this.fn_closeDialog();
                this.showLoading(this.$t('restoreData.deactivatingBusiness'));
                this.$root.fn_getAuthToken(function(token){
                    self.fn_deactivateBusiness(token, item, index);
                })
            },

            fn_deactivateBusiness: function(token, item, index){
                if(!navigator.onLine){
                    this.msgAlert = true;
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }
                
                let self = this;
                let filterObject = {};
                filterObject.businessId = item ? item.BusinessID : this.$root.CurrentBusiness.BusinessID;
                filterObject.token = token;
                filterObject.reloadApp = false;
                this.getServerData('DeactiveBusinessDirect', filterObject, 
                    {
                        onSuccess: function(response){
                            self.hideLoading();
                            console.log(response);
                            if(item){
                                self.showToast(self.$t('restoreData.businessDeletedPrefix') + item.BusinessName + self.$t('restoreData.businessDeletedSuffix'));
                                self.businessList.splice(index, 1);
                            }
                            else{
                                self.showToast(self.$t('restoreData.businessDeletedPrefix') + self.$root.CurrentBusiness.BusinessName + self.$t('restoreData.businessDeletedSuffix'));
                                self.$root.CurrentBusiness = null;
                                self.businessList.splice(0, 1);
                            }

                            if(self.businessList && self.businessList.length){
                                self.$root.CurrentBusiness = self.businessList[0];
                            }
                            else{
                                // self.fn_newBusiness();
                                // self.fn_userType();
                                self.fn_login();
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.msgAlert = true;
                            self.hideLoading();
                        }, 
                    }
                );
            },

            // fn_newBusiness: function(){
            //     this.$router.replace({path:'/registration/business/register'});
            // },

            // fn_userType: function(){
            //     this.$router.replace({path:'/registration/business/usertype'});
            // },

            fn_login: function(){
                this.$router.replace({path:'/registration/business/login'});
            },

            fn_goBack: function(){
                if(this.dialog_update){
                    this.dialog_update = false;
                }
                else{
                    this.fn_quit();
                }
            },

            fn_openPermissionDialog: function(permissionType){
                this.permissionType = permissionType;
                this.fn_openDialogWeb('web', 'Permission', 'ref_dialogPermission');
            },

            fn_openPlayStore: function(){
                this.dialog_update = false;
                this.getData("OpenPlayStore", null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_getRestoredBusinessDetails: function(){
                let self = this;
                this.getData('AllBusiness', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let data = JSON.parse(response);
                           if(data && data.currentBusiness && data.currentBusiness.GSTRegistrationStatus != self.$root.CurrentBusiness.GSTRegistrationStatus){
                                self.$root.fn_updateTtf(function(){
                                    self.fn_saveBusinessDetail('loadMainApp');
                                })
                            }
                            else{
                                self.$root.fn_loadMainApp();
                            }
                        },
                        onError: function(error){
                            console.log(error);
                            self.showToast(self.$t('common.somethingWentWrong'));
                            self.hideLoading();
                        }
                    }
                );
            },

            fn_logOut: function(){
                this.fn_updateRestoreStatus(0, ()=>{
                    this.$router.replace('/');
                })
            },

            fn_restoreFromFirebase: function(){
                this.showLoading(this.$t('common.pleaseWait'));
                let self = this;
                // let filterObject = {"businessId":"0d269b56-4604-4f4a-83d0-0d560fb65998","fileName":"0d269b56-4604-4f4a-83d0-0d560fb65998.gz","filePath":"/tickets/b59df648-c641-466a-b865-f726629831be/bc9d13a9-a6bc-497d-a76f-56cb2b1bb6ea/00bd4106-e61d-4a43-9452-fc8f0efb3636/0d269b56-4604-4f4a-83d0-0d560fb65998.gz"};
                let filterObject = {"businessId":this.$root.CurrentBusiness.BusinessID,"fileName":this.$root.CurrentBusiness.BusinessID + ".gz","filePath":"/tickets/b59df648-c641-466a-b865-f726629831be/bc9d13a9-a6bc-497d-a76f-56cb2b1bb6ea/00bd4106-e61d-4a43-9452-fc8f0efb3636/"+ this.$root.CurrentBusiness.BusinessID +".gz"};
                console.log(JSON.stringify(filterObject));
                this.getFilterData('RestoreBackupFromFirebase', null, filterObject,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.restoreStatus = null;
                            self.hideLoading();
                            if(localStorage.getItem('partial_restore')){
                                localStorage.removeItem('partial_restore');
                            }
                            self.fn_updateRestoreStatus(null);
                        }, 
                        onError: function(error){
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrongShort'));
                            console.log(error);
                        }
                    }
                );
            },

            fn_freshStartDialog: function(){
                this.confirmationHeader = this.$t('restoreData.startWithNewDataHeader');
                this.confirmationMessage = this.$t('restoreData.startWithNewDataMessage');
                // this.actionMethod = this.fn_freshStart;
                this.actionMethod = this.fn_showGoogleAccounts;
                this.fn_openDialogConfirmation('fresh_data');
            },

            fn_freshStart: function(){
                // this.fn_closeDialog();
                this.fn_reopenDatabase(-1, 'fresh_data');
            }

            // fn_checkDatabaseFile: function(){
            //     let self = this;
            //     let businessId = this.$root.CurrentBusiness && this.$root.CurrentBusiness.BusinessID ? this.$root.CurrentBusiness.BusinessID : this.$route.query.activeBusinessId;
            //     this.getData('CheckBusinessFileExists', businessId, 
            //         {
            //             onSuccess: function(response){
            //                 console.log(response);
            //                 self.dbFileExist = JSON.parse(response);
            //             }, 
            //             onError: function(error){
            //                 console.log(error);
            //             }
            //         }
            //     );
            // }
        },
        mounted: function(){
            this.dialogStorageId = this.guidWeb();
            AndroidRoutingTest.revokeAccount();
            this.fn_updateRestoreStatus(-1);
            // this.fn_checkDatabaseFile();
            window.js_globals.fn_setRestoreStatus = this.fn_setRestoreStatus;
            window.js_globals.fn_onBackPress = this.fn_goBack;
            window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
        },
        beforeRouteLeave (to, from, next) {
            var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
            if(dialogData && dialogData.length){
                dialogjs.fn_checkAndCloseOpenDialogs(this);
                AndroidRoutingTest.revokeAccount();
                next(false);
            }
            else{
                next();
            }
        }
    }
</script>